
import * as React from "react";
import {
    Box,
    Text,
    InlineStack,
    Icon,
    OptionList,
    Scrollable
} from '@shopify/polaris';
import {
    ChevronRightIcon
} from '@shopify/polaris-icons';
import { useState, useEffect, useRef } from 'react';

export default function CascadingMenu(props) {
    const [allPurposeKey, setAllPurposeKey] = useState(true);
    const [secondMenuActive, setSecondMenuActive] = useState(false);
    const [currentSecondMenuIndex, setCurrentSecondMenuIndex] = useState(0);
    // const [selected2, setSelected2] = useState([]);
    const setSelected2 = (value) => {
        return value;
    }
    const {
        active = false,
        activator = null,
        onClose = () => {
            setAllPurposeKey(false);
        },
        items,
        onChoose = () => {
            setAllPurposeKey(false);
        },
    } = props;
    const boxRef = useRef(null);
    const handleClickOutside = (event) => {
        if (boxRef.current && !boxRef.current.contains(event.target)) {
            if (onClose != null) {
                onClose();
            }
            // 如果点击事件的目标不在boxRef引用的元素内部，则执行逻辑
        }
    };
    useEffect(() => {
        // 在全局范围监听点击事件
        document.addEventListener('click', handleClickOutside, true);

        return () => {
            // 组件卸载时移除监听
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    if (items == null) {
        return <div ref={boxRef}></div>;
    }
    return (
        <div ref={boxRef}>
            <Box> {activator} </Box>
            <Box style={{ position: 'relative', maxHeight: "300px" }} onMouseLeave={() => {
                setSecondMenuActive(false);
            }}>
                {active && allPurposeKey ? <Box style={{
                    boxShadow: "var(--p-shadow-bevel-100)",
                    background: "var(--p-color-bg-surface)",
                    borderRadius: "var(--p-border-radius-300)",
                    position: "absolute",
                    top: "0px",
                    left: "0px",
                    "::before": {
                        boxShadow: "var(--p-shadow-bevel-100)"
                    },
                    zIndex: "400",
                    margin: "var(--p-space-100) 0px var(--p-space-400)",
                    maxHeight: "300px",
                }}>
                    <Box>
                        <Scrollable style={{ height: '300px' }} focusable>
                            <OptionList
                                onChange={setSelected2}
                                options={
                                    items.map((item, index) => {
                                        return {
                                            value: item.option, label: <Box style={{ width: "186px" }} onMouseOver={() => {
                                                setSecondMenuActive(true);
                                                setCurrentSecondMenuIndex(index);
                                            }}>
                                                <InlineStack blockAlign="center" align="space-between">
                                                    <Box style={{ maxWidth: "160px" }}><Text variant="bodyMd" breakWord={true} truncate={true}>{item.option} </Text></Box>
                                                    <Box><Icon
                                                        source={ChevronRightIcon}
                                                        tone="base"
                                                    /></Box>
                                                </InlineStack>
                                            </Box>
                                        }
                                    })
                                }
                                selected={[]}
                            />
                        </Scrollable>
                    </Box>
                    {secondMenuActive ? <Box style={{
                        height: "100%",
                        position: "absolute",
                        top: "0px",
                        left: "210px",
                    }}>
                        <Box style={{
                            boxShadow: "var(--p-shadow-bevel-100)",
                            background: "var(--p-color-bg-surface)",
                            borderRadius: "var(--p-border-radius-300)",
                            "::before": {
                                boxShadow: "var(--p-shadow-bevel-100)"
                            },
                            zIndex: "400",
                        }}>
                            <Box >
                                <Scrollable style={{ height: '300px' }} focusable>
                                    <OptionList
                                        onChange={setSelected2}
                                        options={
                                            items.length > currentSecondMenuIndex && items[currentSecondMenuIndex].children != null ?
                                                items[currentSecondMenuIndex].children.map(item => {

                                                    return {
                                                        value: item.value, label: <Box style={{ width: "176px" }} onClick={() => {
                                                            onChoose(item.value, item.option);
                                                            onClose();
                                                        }}>
                                                            <Text variant="bodyMd" breakWord={true} truncate={true}>{item.option}</Text>
                                                        </Box>
                                                    }
                                                })
                                                : []
                                        }
                                        selected={[]}
                                    />
                                </Scrollable>
                            </Box>
                        </Box>
                    </Box> : null}

                </Box> : null}
            </Box>
        </div>
    )
}